const WA_NUMBER = "919991634599";
const MSG = "नमस्ते 🙏 मुझे ग्राम पाठशाला मानपुर — हरियाणा दिवस खेल प्रतियोगिता 2026 के पंजीकरण के बारे में मदद चाहिए।\nHello, I need help with the Sports Meet 2026 registration.";
export const WA_HELP_URL = `https://api.whatsapp.com/send?phone=${WA_NUMBER}&text=${encodeURIComponent(MSG)}`;

const WaIcon = ({ size = 28 }) => (
  <svg width={size} height={size} viewBox="0 0 32 32" fill="currentColor" aria-hidden="true">
    <path d="M16.04 3C9.4 3 4 8.36 4 14.97c0 2.11.56 4.17 1.62 5.99L4 29l8.25-1.6a12.1 12.1 0 0 0 3.79.6C22.68 28 28 22.64 28 16.03 28 9.42 22.68 3 16.04 3Zm0 22.4c-1.2 0-2.38-.2-3.5-.6l-.6-.2-4.9.95.98-4.73-.22-.62A9.6 9.6 0 0 1 6.4 15c0-5.3 4.33-9.6 9.64-9.6 5.32 0 9.56 4.3 9.56 10.6 0 5.3-4.24 9.4-9.56 9.4Zm5.3-7.1c-.29-.15-1.72-.85-1.99-.94-.27-.1-.46-.15-.66.14-.19.29-.75.94-.92 1.13-.17.2-.34.22-.63.07-.29-.15-1.22-.45-2.33-1.43-.86-.76-1.44-1.7-1.61-1.99-.17-.29-.02-.44.13-.59.13-.13.29-.34.43-.5.15-.17.2-.29.29-.48.1-.2.05-.37-.02-.51-.08-.15-.66-1.58-.9-2.16-.24-.57-.48-.49-.66-.5h-.56c-.2 0-.51.07-.78.36-.27.29-1.02 1-1.02 2.43 0 1.43 1.05 2.82 1.2 3.01.14.2 2.06 3.13 5 4.39.7.3 1.24.48 1.67.61.7.22 1.34.19 1.84.12.56-.08 1.72-.7 1.97-1.38.24-.68.24-1.26.17-1.38-.07-.12-.27-.2-.56-.34Z" />
  </svg>
);

export const WhatsAppFab = () => (
  <a href={WA_HELP_URL} target="_blank" rel="noopener noreferrer" className="wa-fab no-print" aria-label="WhatsApp Help" data-testid="whatsapp-help-fab">
    <WaIcon />
    <span className="wa-fab-label font-hi">मदद चाहिए? · Help</span>
  </a>
);

export const WhatsAppHelpCard = () => (
  <div className="help-card" data-testid="whatsapp-help-card">
    <span className="help-icon"><WaIcon size={26} /></span>
    <div className="flex-1 min-w-[200px]">
      <p className="font-hi font-bold text-navy">पंजीकरण में कोई परेशानी? हम मदद करेंगे!</p>
      <p className="text-sm text-slate-500">Need help with registration? Chat with us on WhatsApp.</p>
    </div>
    <a href={WA_HELP_URL} target="_blank" rel="noopener noreferrer" className="btn-whatsapp btn-sm w-full sm:w-auto justify-center" data-testid="whatsapp-help-card-btn">
      WhatsApp करें
    </a>
  </div>
);
